import {
  displayTokenToLabelFilter,
  labelFilterToDisplayToken,
} from '@ipfabric/utils';

export const formatDisplayLabel = (name: string, value?: string): string =>
  labelFilterToDisplayToken(
    value !== undefined && value !== '' ? { name, value } : { name },
  );

export const parseDisplayLabel = (
  label: string,
): { name: string; value?: string } => {
  const parsed = displayTokenToLabelFilter(label);
  return {
    name: parsed.name,
    ...(parsed.value !== undefined && parsed.value !== ''
      ? { value: parsed.value }
      : {}),
  };
};
